import { default as FormControlLabel } from '@mui/material/FormControlLabel'
import { default as MuiSwitch, SwitchProps } from '@mui/material/Switch'
import * as React from 'react'

export interface Props extends SwitchProps {
  label: React.ReactNode
}

const Switch: React.FC<React.PropsWithChildren<Props>> = ({ label, ...props }) => {
  return (
    <FormControlLabel
      label={label}
      disabled={props.disabled}
      control={<MuiSwitch inputProps={{ 'aria-label': label as string }} {...props} />}
    />
  )
}

export default Switch
